module.exports = __webpack_public_path__ + "img/5-3.30a704e3.svg";